import { useEffect, useState} from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import axios from "axios";
import { QrReader } from "react-qr-reader";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function ListCheckout({
  handleClose,
  assetLocations,
  refreshAssets,
}) {
  const url = process.env.REACT_APP_URL;
  const [listName, setListName] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(0);
  const [assets, setAssets] = useState([]);
  const [assetId, setAssetId] = useState("");
  const [scanned, setScanned] = useState(false);
  const [scannedAsset, setScannedAsset] = useState(0);
  //Alerts & Loader
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);
  //Modals
  const [openView, setOpenView] = useState(false);

  useEffect(() => {
    if (scannedAsset != 0) {
      addAsset(scannedAsset);
    }
  }, [scannedAsset]);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const addAsset = async (assetId) => {
    setAssetId("");
    await axios
      .post(`${url}/assets/fetch-asset`, { assetId: assetId })
      .then(async (res) => {
        let _asset = res.data.asset;
        console.log(_asset);

        if (!_asset.checkedIn || _asset.disabled || _asset.archived) {
          handleAlert(
            "This asset is already checked out, is disabled or is archived",
            "warning"
          );
          return;
        }

        let assetExists = assets.findIndex((a) => {
          return a.assetId == _asset.assetId;
        });

        if (assetExists >= 0) {
          handleAlert("Asset already in list", "warning");
        } else {
          setAssets((prevItems) => [
            {
              assetId: _asset.assetId,
              assetName: _asset.assetName,
              serialNumber: _asset.serialNumber,
            },
            ...prevItems,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Unable to find this asset", "error");
      });
  };

  const removeAsset = (assetId) => {
    let filteredAssets = assets.filter((a, i) => {
      return a.assetId != assetId;
    });
    setAssets(filteredAssets);
  };

  const handleValidation = () => {
    setDisable(true);
    if (listName === "") {
      handleAlert("Please enter a list name", "warning");
    } else if (selectedLocation === 0) {
      handleAlert("Please select a location", "warning");
    }
    // else if (assets.length == 0) {
    //   handleAlert("Please add more than one asset to your list", "Warning");
    // }
    else {
      handleCreateList();
    }
  };

  const handleCreateList = async () => {
    console.log(assets);
    //Remove any list duplicates
    const uniqueArray = assets.filter(
      (value, index, self) =>
        self.findIndex((item) => item.assetId === value.assetId) === index
    );

    let reqBody = {
      listName: listName,
      listLocation: selectedLocation,
      listAssets: uniqueArray,
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
    };
 
    await axios
      .post(`${url}/assets/create-list`, reqBody)
      .then((res) => {
        handleAlert("List created", "success", 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });
  };

  return (
    <Box className="list-modal">
      <section className="list-section">
        <h2>Create List Checkout</h2>
        <form>
          <p>List Name</p>
          <input
            placeholder="What's your list called?"
            value={listName}
            onChange={(e) => setListName(e.target.value)}
          />
          <p>Where are you taking these assets?</p>
          <select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value={0}>Please select a location</option>
            {assetLocations.length > 0
              ? assetLocations.map((a, i) => {
                  return (
                    <option key={i} value={a.locationId}>
                      {a.locationName}
                    </option>
                  );
                })
              : null}
          </select>
          {!scanned ? (
            <QrReader
              onResult={(result, error) => {
                if (result?.text) {
                  setScannedAsset(result?.text);
                  setTimeout(() => {
                    setScannedAsset(0);
                  }, 2000);
                }
              }}
              style={{ width: "100%" }}
              className="qr-reader"
              constraints={{
                facingMode: "environment",
              }}
            />
          ) : (
            <Button
              className="scan-btn"
              variant="contained"
              color="info"
              onClick={() => {
                setScanned(false);
              }}
            >
              Scan Another
            </Button>
          )}{" "}
          <section className="manual-asset">
            <input
              placeholder="Enter Asset ID manually if no QR"
              onChange={(e) => setAssetId(e.target.value)}
              type="text"
              value={assetId}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={assetId === ""}
              onClick={() => {
                addAsset(assetId);
              }}
            >
              <AddCircleIcon />
            </Button>
          </section>
        </form>
        <section className="asset-list-container">
          {assets.length > 0 ? (
            <table className="asset-list-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {assets.map((a, i) => {
                  return (
                    <tr key={i}>
                      <td>{a.assetId}</td>
                      <td>{a.assetName}</td>
                      <td>
                        <IconButton
                          disabled={disable}
                          onClick={() => {
                            removeAsset(a.assetId);
                          }}
                        >
                          <DeleteIcon color="error" fontSize="large" />
                        </IconButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : null}
        </section>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            onClick={() => handleClose(false)}
            variant="contained"
            color="error"
            disabled={disable}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={disable}
            onClick={handleValidation}
          >
            Submit
          </Button>
        </section>
      </section>
    </Box>
  );
}
